module.exports = __webpack_public_path__ + "static/floor_preview__4-9e455d0501e293fcb07d4c353bb9db81.png";